import { render, staticRenderFns } from "./shoppingGuide.vue?vue&type=template&id=30bdfbf4&scoped=true&"
import script from "./shoppingGuide.vue?vue&type=script&lang=js&"
export * from "./shoppingGuide.vue?vue&type=script&lang=js&"
import style0 from "./shoppingGuide.vue?vue&type=style&index=0&id=30bdfbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdfbf4",
  null
  
)

component.options.__file = "shoppingGuide.vue"
export default component.exports